// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3nC1i","footer":"ReportModalFilter_footer__4L42n"};